import * as types from "../mutation-types";
import axios from "axios";

export const state = () => ({
  coloredProducts: [],
  currentPage: null,
  nextPage: null,
  lastPage: null,
  currencySymbol: null,
  loading: null,
  numberOfDecimals: 0,
  totalProducts: 0,
});

export const getters = {
  currencySymbol: (state) => state.currencySymbol,
  coloredProducts: (state) => state.coloredProducts,
  currentPage: (state) => state.currentPage,
  nextPage: (state) => state.nextPage,
  lastPage: (state) => state.lastPage,
  lastPageParsed: (state) =>
    state.coloredProducts.last_page_url
      ? state.coloredProducts.last_page_url.split("=")[1]
      : null,
  loading: (state) => state.loading,
  numberOfDecimals: (state) => state.numberOfDecimals,
  totalProducts: (state) => state.totalProducts,
};

export const mutations = {
  [types.SET_CURRENCY_SYMBOL](state, currencySymbol) {
    state.currencySymbol = currencySymbol;
  },
  [types.SET_LOADING](state, status) {
    state.loading = status;
  },
  SET_COLORED_PRODUCTS(state, coloredProducts) {
    state.coloredProducts = coloredProducts;
  },
  MERGE_ES_COLORED_PRODUCTS(state, coloredProducts) {
    state.coloredProducts.data = [
      ...state.coloredProducts.data,
      ...coloredProducts,
    ];
  },
  MERGE_COLORED_PRODUCTS(state, coloredProducts) {
    state.coloredProducts = [...state.coloredProducts, ...coloredProducts];
  },
  SWAP_PAGINATION_AFTER_MERGE(state, paginationData) {
    let mergedColoredProducts = state.coloredProducts.data;
    state.coloredProducts = paginationData;
    state.coloredProducts.data = mergedColoredProducts;
  },
  PUSH_COLORED_PRODUCTS(state, additionalProducts) {
    state.coloredProducts = [...state.coloredProducts, ...additionalProducts];
  },
  SET_CURRENT_PAGE(state, currentPage) {
    if (currentPage) {
      state.currentPage = currentPage;
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    let pageNumber = parseInt(urlParams.get("page"));
    if (!isNaN(pageNumber)) {
      state.currentPage = pageNumber;
    }
  },
  SET_NEXT_PAGE(state, nextPage) {
    state.nextPage = nextPage;
  },
  SET_LAST_PAGE(state, lastPage) {
    state.lastPage = lastPage;
  },
  [types.SET_NUMBER_OF_DECIMALS](state, numberOfDecimals) {
    state.numberOfDecimals = numberOfDecimals;
  },
  SET_TOTAL_PRODUCTS(state, totalProducts) {
    state.totalProducts = totalProducts;
  },
};

export const actions = {
  async fetchElasticColoredProducts(
    { commit, rootGetters, getters },
    { url, merge = false }
  ) {
    const response = await axios.get(url, {
      params: {
        queryString: rootGetters["product-filters/queryFilters"],
        sort: rootGetters["product-filters/order"]?.value,
      },
    });
    if (merge) {
      commit("MERGE_ES_COLORED_PRODUCTS", response.data.colored_products.data);
      commit("SWAP_PAGINATION_AFTER_MERGE", response.data.colored_products);
    } else {
      commit("SET_COLORED_PRODUCTS", response.data.colored_products);
    }

    commit("SET_LAST_PAGE", response.data.colored_products.last_page);

    return response;
  },
  async fetchColoredProductsNew(
    { commit, rootGetters, getters },
    { url, page, merge = false }
  ) {
    const response = await axios.get(url, {
      params: {
        queryString: rootGetters["product-filters/queryFilters"],
        sort: rootGetters["product-filters/order"]?.value,
      },
    });
    if (merge) {
      //   commit("MERGE_COLORED_PRODUCTS", response.data.data);
      try {
        commit("MERGE_COLORED_PRODUCTS", response.data.colored_products);
      } catch (error) {
        commit("MERGE_COLORED_PRODUCTS", response.data.data);
      }
    } else {
      //temporary need to have same structure of response as product list for category page in future
      if (url.includes("es-search")) {
        commit("SET_COLORED_PRODUCTS", response.data.data);
      } else {
        if (response.data.data) {
          commit("SET_COLORED_PRODUCTS", response.data.data);
        } else {
          commit("SET_COLORED_PRODUCTS", response.data.colored_products);
        }
      }
    }
    return response;
  },
  async fetchColoredProducts(
    { commit, rootGetters, getters },
    { url, page, merge = false }
  ) {
    const response = await axios.get(url, {
      params: {
        page: page,
        queryString: rootGetters["product-filters/queryFilters"],
        sort: rootGetters["product-filters/order"]?.value,
      },
    });
    if (merge) {
      //   commit("MERGE_COLORED_PRODUCTS", response.data.data);
      try {
        commit("MERGE_COLORED_PRODUCTS", response.data.colored_products);
      } catch (error) {
        commit("MERGE_COLORED_PRODUCTS", response.data.data);
      }
    } else {
      //temporary need to have same structure of response as product list for category page in future
      if (url.includes("es-search")) {
        commit("SET_COLORED_PRODUCTS", response.data.data);
      } else {
        if (response.data.data) {
          commit("SET_COLORED_PRODUCTS", response.data.data);
        } else {
          commit("SET_COLORED_PRODUCTS", response.data.colored_products);
        }
      }
    }
    return response;
  },
};
